import { Button } from '@chakra-ui/react';
import { useState } from 'react';
import { AiOutlineDownload } from 'react-icons/ai/index.js';

export interface DownloadLayoutButtonProps {
  onDownload: () => Promise<void>;
  title?: string;
}

export const DownloadLayoutButton = (props: DownloadLayoutButtonProps) => {
  const { title = '' } = props;
  const [isProcessing, setIsProcessing] = useState(false);
  return (
    <Button
      colorScheme='blue'
      isLoading={isProcessing}
      h={8}
      sx={{
        boxShadow: 'lg',
      }}
      onClick={(_e) => {
        setIsProcessing(true);
        props
          .onDownload()
          .then((a) => {
            setIsProcessing(false);
            return a;
          })
          .catch((err) => {
            setIsProcessing(false);
            throw err;
          });
      }}
      leftIcon={<AiOutlineDownload />}
    >
      {`Download ${title?.slice(title.indexOf(' '))}`}
    </Button>
  );
};
